/**
 * @type {Array} Yandex data layer
 */
window.dataLayer = window.dataLayer || [];

export class YandexMetrika {

    onLoadDetail(product) {
        if (product) {
            window.dataLayer.push({
                'ecommerce': {
                    'detail': {
                        'products': [{
                            'name': _.get(product, 'name', ''),
                            'id': _.get(product, 'id', ''),
                            'price': _.get(product, 'price', ''),
                            'brand': _.get(product, 'brand', ''),
                            'category': _.has(product, 'category.name') ? _.get(product, 'category.name') : _.get(product, 'category', ''),
                        }]
                    }
                }
            });
        }
    }
    onAddToCart(product) {
        if (product) {
            window.dataLayer.push({
                'ecommerce': {
                    'add': {
                        'products': [{
                            'name': _.get(product, 'name', ''),
                            'id': _.get(product, 'id', ''),
                            'price': _.get(product, 'price', ''),
                            'brand': _.get(product, 'brand', ''),
                            'category': _.has(product, 'category.name') ? _.get(product, 'category.name') : _.get(product, 'category', ''),
                            'quantity': _.get(product, 'quantity', 1),
                        }]
                    }
                }
            });
        }
    }
    onRemoveFromCart(products) {
        if (products) {
            window.dataLayer.push({
                'ecommerce': {
                    'remove': {
                        'products': products.map(function (product) {
                            return {
                                'name': _.get(product, 'name', ''),
                                'id': _.get(product, 'id', ''),
                                'price': _.get(product, 'price', ''),
                                'brand': _.get(product, 'brand', ''),
                                'category': _.has(product, 'category.name') ? _.get(product, 'category.name') : _.get(product, 'category', ''),
                                'quantity': _.get(product, 'quantity', 1),
                            }
                        })
                    }
                }
            });
        }
    }
    onPurchased(order, products) {
        if (order && products) {
            window.dataLayer.push({
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: _.get(order, 'order_id', ''),
                            revenue: _.get(order, 'revenue', ''),
                            shipping: _.get(order, 'shipping', ''),
                        },
                        products: products.map(product => {
                            return {
                                name: _.get(product, 'name', ''),
                                id: _.get(product, 'id', ''),
                                price: _.get(product, 'price', ''),
                                brand: _.get(product, 'brand', ''),
                                category: _.has(product, 'category.name') ? _.get(product, 'category.name') : _.get(product, 'category', ''),
                                quantity: _.get(product, 'quantity', 1),
                            }
                        })
                    }
                }
            });
        }
    }
}
